<script>
import { api } from "@/state/services";
import { maskCurrency, parseCurrency } from "@/utils/masks";

// Bloqueia o uso do menu Afiliados até o Consultor/Regional informar o valor
// fixo da adesão, usado como base inicial do campo "Valor da Adesão" dos leads.
export default {
  name: "AdesaoGateModal",
  data() {
    return {
      checked:  false,
      visible:  false,
      value:    "",
      error:    "",
      loading:  false,
    };
  },
  created() {
    api.get("afiliados/settings").then((r) => {
      if (r.data.status === "success" && r.data.settings.adesao_value === null) {
        this.visible = true;
      }
    }).finally(() => { this.checked = true; });
  },
  methods: {
    maskCurrency,
    save() {
      this.error = "";
      const value = parseCurrency(this.value);
      if (!value || value < 250) {
        this.error = "Informe um valor de, no mínimo, R$ 250,00.";
        return;
      }
      this.loading = true;
      api.put("afiliados/settings", { adesao_value: value })
        .then((r) => {
          if (r.data.status === "success") {
            this.visible = false;
          } else {
            this.error = r.data.message || "Erro ao salvar.";
          }
        })
        .catch(() => { this.error = "Erro ao salvar. Tente novamente."; })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="visible"
    title="Valor Fixo da Adesão"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    centered
  >
    <p class="mb-3">
      Informe o valor Fixo da sua adesão Mínimo R$250,00, esse valor será utilizado como base
      inicial para o preenchimento do valor de adesão dos Leads que forem indicados, esse valor
      poderá ser alterado individualmente após a negociação individualmente de cada Lead.
    </p>

    <div v-if="error" class="alert alert-danger py-2 small">{{ error }}</div>

    <b-form @submit.prevent="save">
      <b-form-group label="Valor Fixo da Adesão *">
        <b-input-group prepend="R$">
          <b-form-input
            :value="value"
            placeholder="0,00"
            autocomplete="off"
            required
            @input="value = maskCurrency($event)"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <div class="text-right mt-3">
        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner v-if="loading" small class="mr-1"></b-spinner>
          Salvar
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
